var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"ui-plan-limits",attrs:{"src":"/images/badge-dollar.svg","alt":"badge-dollar"}})}
var staticRenderFns = []

export { render, staticRenderFns }